import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import ActionableFilterPill from '../../index';

const getDisplayName = (appliedStoreFilters) => {
  if (appliedStoreFilters.length === 0) {
    return <FormattedMessage defaultMessage='Allocation Status' description='filterOptions.allocationStatus' id='JbPY93' />;
  }
  const [filter] = appliedStoreFilters;
  if (filter.criterionArgumentValue) {
    return <FormattedMessage defaultMessage='Allocated' description='filterOptions.allocated' id='rlVkKF' />;
  }
  return <FormattedMessage defaultMessage='Unallocated' description='filterOptions.unallocated' id='sqeP5r' />;
};

const ConnectedActionablePill = forwardRef((props, ref) => {
  const appliedFilters = useSelector((state) =>
    Global.selectOrdersFilteringActiveFilterViewFiltersById(state, {
      filterById: props.filterById,
    }),
  );
  const displayContent = useMemo(() => getDisplayName(appliedFilters), [appliedFilters]);
  return <ActionableFilterPill {...props} ref={ref} displayContent={displayContent} isSelected={!!appliedFilters.length} />;
});

ConnectedActionablePill.propTypes = {
  filterById: PropTypes.string,
};

export default ConnectedActionablePill;
